import { Component } from '@angular/core';

@Component({
  selector: 'opac-no-results-cta',
  templateUrl: './no-results-cta.component.html',
  styleUrls: ['./no-results-cta.component.scss']
})
export class NoResultsCtaComponent {
}
